// Customer API

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { CUSTOMERS } = API_ENDPOINTS;

export const customerApi = {
  /** GET /admin/customers/ */
  getList: () => axiosInstance.get(CUSTOMERS.LIST),

  /** GET /admin/customers/{id}/ */
  getDetail: (id) => axiosInstance.get(CUSTOMERS.DETAIL(id)),

  /** GET /admin/customers/report/?period=today|week|month|year|all&q=
   *  Every customer with what they asked for and what they actually paid. */
  getReport: (params = {}) => axiosInstance.get(CUSTOMERS.REPORT, { params }),

  /** GET /admin/customers/{id}/report/?period=…
   *  One customer in full — inquiries, parts, returns, follow-ups. */
  getOneReport: (id, params = {}) =>
    axiosInstance.get(CUSTOMERS.ONE_REPORT(id), { params }),
};
